import { render, staticRenderFns } from "./HSkeleton.vue?vue&type=template&id=63cbe626&scoped=true&"
import script from "./HSkeleton.vue?vue&type=script&lang=js&"
export * from "./HSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./HSkeleton.vue?vue&type=style&index=0&id=63cbe626&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cbe626",
  null
  
)

export default component.exports